/*
  Phase 2b — Variant picker: routes each product option to swatch / chip / segmented
  based on product.metafields.custom.option_styles (JSON). Native <select> stays in
  the DOM as the form's source of truth; we replace its visual presentation only.

  Subscribes to nothing. Dispatches nothing. Calls <select>.dispatchEvent(new Event('change'))
  on button click so the existing variant-reactivity service (2a) handles variant resolution.
*/

(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  } else {
    root.TrautisVariantPicker = api;
    if (root.document && root.document.addEventListener) {
      if (root.document.readyState === 'loading') {
        root.document.addEventListener('DOMContentLoaded', api.init);
      } else {
        api.init();
      }
    }
  }
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  var VALID_STYLES = { swatch: 1, chip: 1, segmented: 1 };

  function parseStylesJson(raw) {
    if (!raw || typeof raw !== 'string') return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  function resolveStyle(optionName, styles) {
    if (!styles || typeof styles !== 'object') return 'chip';
    var v = styles[optionName];
    if (v && VALID_STYLES[v]) return v;
    return 'chip';
  }

  function formatEUR(cents) {
    var euros = Math.abs(cents / 100).toFixed(2).replace('.', ',');
    return euros + ' €';
  }

  function computePriceDelta(variantPriceCents, basePriceCents) {
    var delta = variantPriceCents - basePriceCents;
    if (delta === 0) return 'inkl.';
    if (delta > 0)   return '+ ' + formatEUR(delta);
    return '− ' + formatEUR(delta);
  }

  function getProductJSON(sectionRoot) {
    var s = sectionRoot.querySelector('script[type="application/json"][data-product-json]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }

  function getOptionStyles(product) {
    if (!product || !product.metafields) return null;
    var mf = product.metafields.custom && product.metafields.custom.option_styles;
    // Shopify Liquid metafield `json` type can serialize as either a parsed
    // object or its JSON string; tolerate both.
    if (mf && typeof mf === 'object') return mf;
    if (typeof mf === 'string') return parseStylesJson(mf);
    return null;
  }

  function findCheapestPriceForValue(product, optionIndex, value) {
    var best = Infinity;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (v.options[optionIndex] === value && v.price < best) best = v.price;
    }
    return best === Infinity ? null : best;
  }

  function findCheapestVariantPrice(product) {
    var best = Infinity;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].price < best) best = product.variants[i].price;
    }
    return best === Infinity ? 0 : best;
  }

  function isValueAvailable(product, optionIndex, value) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (v.options[optionIndex] === value && v.available) return true;
    }
    return false;
  }

  function findVariantByExactOptions(product, optionValues) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var match = true;
      for (var j = 0; j < optionValues.length; j++) {
        if (optionValues[j] != null && v.options[j] !== optionValues[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  // Verfügbarkeit eines Options-Werts gegen die VOLLSTÄNDIGE prospektive
  // Kombination (aktuelle Auswahl, an optionIndex durch value ersetzt):
  //   'available'         — exakte Kombination existiert und ist lieferbar
  //   'combo-unavailable' — der Wert existiert grundsätzlich (irgendeine
  //                         lieferbare Variante trägt ihn), aber die Kombination
  //                         mit der übrigen Auswahl nicht bzw. nur ausverkauft.
  //                         Button bleibt KLICKBAR: der Klick löst den
  //                         Fallback-Resolve der Reactivity aus (sonst wären
  //                         Varianten wie (A2,B2) aus (A1,B1) heraus unerreichbar).
  //   'disabled'          — keine lieferbare Variante trägt den Wert → hart aus.
  function comboState(product, currentOptions, optionIndex, value) {
    if (!isValueAvailable(product, optionIndex, value)) return 'disabled';
    var combo = currentOptions.slice();
    combo[optionIndex] = value;
    var v = findVariantByExactOptions(product, combo);
    return (v && v.available) ? 'available' : 'combo-unavailable';
  }

  function findVariantByValue(product, optionIndex, value) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (v.options[optionIndex] === value) return v;
    }
    return null;
  }

  function buildButton(value, optionIndex, product, style, selectEl) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 't-picker__btn t-picker__btn--' + style;
    btn.setAttribute('role', 'radio');
    btn.setAttribute('data-option-index', String(optionIndex));
    btn.setAttribute('data-option-value', value);

    var active = (selectEl.value === value);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    if (active) btn.classList.add('is-active');

    var available = isValueAvailable(product, optionIndex, value);
    var exists = !!findVariantByValue(product, optionIndex, value);
    if (!exists) {
      // Wert kommt in KEINER Variante vor → wirklich tot, hart deaktivieren.
      btn.setAttribute('aria-disabled', 'true');
      btn.disabled = true;
      btn.classList.add('is-disabled');
    } else if (!available) {
      // Ausverkauft, aber WÄHLBAR (Owner-Test 2026-07-22): die Auswahl führt zum
      // deaktivierten ATC + „Benachrichtigen"-Flow (notify-OOS). Hart deaktiviert
      // wäre der Restock-Flow bei Mehrvarianten-Produkten unerreichbar — obwohl
      // die Buttons sogar „ab …"-Badges (available_from) dafür rendern.
      btn.classList.add('is-soldout');
      btn.setAttribute('aria-label', value + ' — ausverkauft');
    }

    // Style-specific content
    if (style === 'swatch') {
      var fill = document.createElement('span');
      fill.className = 't-picker__swatch';
      // option_value.swatch.color / .swatch.image come from Shopify; we read
      // them from <option data-swatch-color> / <option data-swatch-image>
      // emitted by the Liquid snippet.
      var optionEl = selectEl.querySelector('option[value="' + value.replace(/"/g, '\\"') + '"]');
      var swColor  = optionEl ? optionEl.getAttribute('data-swatch-color') : null;
      var swImage  = optionEl ? optionEl.getAttribute('data-swatch-image') : null;
      if (swImage) {
        fill.style.backgroundImage = 'url(' + swImage + ')';
        fill.style.backgroundSize = 'cover';
        fill.style.backgroundPosition = 'center';
      } else if (swColor) {
        fill.style.background = swColor;
      } else {
        fill.style.background = '#E5E5E5';
      }
      btn.appendChild(fill);

      // Visually-hidden label for screen readers + the active row label
      var srLabel = document.createElement('span');
      srLabel.className = 'visually-hidden';
      srLabel.textContent = value;
      btn.appendChild(srLabel);

      // OOS badge (if available_from set)
      var variant = findVariantByValue(product, optionIndex, value);
      var availFrom = variant && variant.metafields && variant.metafields.custom && variant.metafields.custom.available_from;
      if (!available && availFrom) {
        var badge = document.createElement('span');
        badge.className = 't-picker__oos-badge';
        // availFrom may be "2026-06-04" → "ab 04.06."
        badge.textContent = formatShortDate(availFrom);
        btn.appendChild(badge);
      }
    } else if (style === 'chip') {
      btn.textContent = value;
    } else if (style === 'segmented') {
      var labelEl = document.createElement('span');
      labelEl.className = 't-picker__seg-label';
      labelEl.textContent = value;
      btn.appendChild(labelEl);

      var deltaEl = document.createElement('span');
      deltaEl.className = 't-picker__seg-delta';
      var cheapForValue = findCheapestPriceForValue(product, optionIndex, value);
      var basePrice = findCheapestVariantPrice(product);
      if (cheapForValue !== null) {
        deltaEl.textContent = computePriceDelta(cheapForValue, basePrice);
      } else {
        deltaEl.textContent = '';
      }
      btn.appendChild(deltaEl);
    }

    btn.addEventListener('click', function (e) {
      if (btn.disabled) return;
      e.preventDefault();
      selectEl.value = value;
      selectEl.dispatchEvent(new Event('change', { bubbles: true }));
    });

    return btn;
  }

  function formatShortDate(isoDate) {
    // "2026-06-04" → "ab 04.06."
    var parts = isoDate.split('-');
    if (parts.length < 3) return 'ab ' + isoDate;
    return 'ab ' + parts[2] + '.' + parts[1] + '.';
  }

  function renderPickerFor(selectEl, product, styles, sectionRoot) {
    var optionIndex = parseInt(selectEl.getAttribute('data-option-index'), 10);
    var optionName  = selectEl.getAttribute('data-option-name') || '';
    var style = resolveStyle(optionName, styles);

    // Collect unique option values from <option> children
    var values = [];
    var seen = {};
    var opts = selectEl.querySelectorAll('option');
    for (var i = 0; i < opts.length; i++) {
      var v = opts[i].value;
      if (!seen[v]) { seen[v] = 1; values.push(v); }
    }

    // Build the picker container
    var container = document.createElement('div');
    container.className = 't-picker t-picker--' + style;
    container.setAttribute('role', 'radiogroup');
    container.setAttribute('aria-label', optionName);
    container.setAttribute('data-picker-option-index', String(optionIndex));

    for (var j = 0; j < values.length; j++) {
      container.appendChild(buildButton(values[j], optionIndex, product, style, selectEl));
    }

    // Insert AFTER the <select> and hide the <select> visually but keep it in flow
    selectEl.parentNode.insertBefore(container, selectEl.nextSibling);
    selectEl.classList.add('visually-hidden');

    function syncActive() {
      var btns = container.querySelectorAll('[data-option-value]');
      btns.forEach(function (b) {
        var match = (b.getAttribute('data-option-value') === selectEl.value);
        b.setAttribute('aria-pressed', match ? 'true' : 'false');
        if (match) b.classList.add('is-active');
        else       b.classList.remove('is-active');
      });
    }

    // Kombi-Verfügbarkeit relativ zur aktuellen Auswahl ALLER Optionen bewerten
    // (nicht nur „gibt es irgendeine Variante mit dem Wert"). Werte, deren
    // Kombination mit der übrigen Auswahl fehlt/ausverkauft ist, werden als
    // .is-unavailable markiert, bleiben aber klickbar (Fallback-Resolve).
    function syncComboStates() {
      var selects = sectionRoot.querySelectorAll('select[data-variant-option]');
      var current = [];
      selects.forEach(function (s) {
        var idx = parseInt(s.getAttribute('data-option-index'), 10);
        current[isNaN(idx) ? current.length : idx] = s.value;
      });
      var btns = container.querySelectorAll('[data-option-value]');
      btns.forEach(function (b) {
        if (b.disabled) return; // Wert nirgends lieferbar → bleibt hart deaktiviert
        var state = comboState(product, current, optionIndex, b.getAttribute('data-option-value'));
        if (state === 'combo-unavailable') b.classList.add('is-unavailable');
        else b.classList.remove('is-unavailable');
      });
    }
    syncComboStates();

    // Re-sync picker buttons when select changes externally (e.g. ?variant= URL)
    selectEl.addEventListener('change', syncActive);
    // Nach jedem aufgelösten Variantenwechsel (inkl. Fallback-Resolve, der die
    // <select>s programmatisch umsetzt — dabei feuert KEIN change-Event):
    // aktive Buttons und Kombi-Verfügbarkeit neu bewerten.
    sectionRoot.addEventListener('trautis:variant-change', function () {
      syncActive();
      syncComboStates();
    });
  }

  function initSection(sectionRoot) {
    var product = getProductJSON(sectionRoot);
    if (!product) return;
    var styles = getOptionStyles(product);
    var selects = sectionRoot.querySelectorAll('select[data-variant-option]');
    selects.forEach(function (sel) { renderPickerFor(sel, product, styles, sectionRoot); });
  }

  function init() {
    var sections = document.querySelectorAll('[data-product-section]');
    sections.forEach(initSection);
  }

  return {
    init: init,
    resolveStyle: resolveStyle,
    parseStylesJson: parseStylesJson,
    computePriceDelta: computePriceDelta,
    comboState: comboState
  };
});
